import React, { useState, useEffect, useReducer, useContext } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
import Chip from "@material-ui/core/Chip";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from "@material-ui/core/Badge";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import DescriptionIcon from "@material-ui/icons/Description";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import PauseCircleOutlineIcon from "@material-ui/icons/PauseCircleOutline";
import AddIcon from "@material-ui/icons/Add";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import PeopleIcon from "@material-ui/icons/People";
import ListAltIcon from "@material-ui/icons/ListAlt";
import AssessmentIcon from "@material-ui/icons/Assessment";
import GetAppIcon from "@material-ui/icons/GetApp";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
  Box,
  Typography,
} from "@material-ui/core";
import { isArray } from "lodash";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ConfirmationModal from "../../components/ConfirmationModal";
import toastError from "../../errors/toastError";
import { useDate } from "../../hooks/useDate";
import ForbiddenPage from "../../components/ForbiddenPage";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";
import CampaignProModal from "../../components/CampaignProModal";
import ContactListProImportWizard from "../../components/ContactListProImportWizard";
import ManualAddContactsModal from "../../components/ManualAddContactsModal";

const reducer = (state, action) => {
  if (action.type === "LOAD_DATA") {
    const data = action.payload;
    const newData = [];
    if (isArray(data)) {
      data.forEach((item) => {
        const index = state.findIndex((u) => u.id === item.id);
        if (index !== -1) {
          state[index] = item;
        } else {
          newData.push(item);
        }
      });
    }
    return [...state, ...newData];
  }
  if (action.type === "UPDATE_DATA") {
    const item = action.payload;
    const index = state.findIndex((u) => u.id === item.id);
    if (index !== -1) {
      state[index] = item;
      return [...state];
    } else {
      return [item, ...state];
    }
  }
  if (action.type === "DELETE_DATA") {
    const id = action.payload;
    const index = state.findIndex((u) => u.id === id);
    if (index !== -1) {
      state.splice(index, 1);
    }
    return [...state];
  }
  if (action.type === "RESET") {
    return [];
  }
  return state;
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  tabsContainer: {
    marginBottom: theme.spacing(2),
  },
  statsCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: "#f5f5f5",
    borderRadius: 8,
  },
  tableHeader: {
    fontWeight: "bold",
    backgroundColor: theme.palette.grey[100],
  },
  statusChip: {
    fontSize: "0.75rem",
  },
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(6),
    color: theme.palette.text.secondary,
  },
  actionButtons: {
    display: "flex",
    gap: theme.spacing(1),
  },
}));

const CampaignsPro = () => {
  const classes = useStyles();
  const history = useHistory();
  const { user, socket } = useContext(AuthContext);
  const { datetimeToClient } = useDate();
  const { getPlanCompany } = usePlans();

  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [searchParam, setSearchParam] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  // Campanhas
  const [campaigns, dispatchCampaigns] = useReducer(reducer, []);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [deletingCampaign, setDeletingCampaign] = useState(null);
  const [campaignModalOpen, setCampaignModalOpen] = useState(false);
  const [confirmCampaignModalOpen, setConfirmCampaignModalOpen] = useState(false);

  // Listas de Contatos
  const [contactLists, dispatchContactLists] = useReducer(reducer, []);
  const [deletingContactList, setDeletingContactList] = useState(null);
  const [importWizardOpen, setImportWizardOpen] = useState(false);
  const [confirmContactListModalOpen, setConfirmContactListModalOpen] = useState(false);
  const [manualAddModalOpen, setManualAddModalOpen] = useState(false);
  const [selectedListForManualAdd, setSelectedListForManualAdd] = useState(null);
  const [selectedListForImport, setSelectedListForImport] = useState(null);
  const [validatingListId, setValidatingListId] = useState(null);
  const [exportingListId, setExportingListId] = useState(null);

  // Verificar permissÃ£o de campanhas
  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);
      if (!planConfigs.plan.useCampaigns) {
        toast.error("Esta empresa nÃ£o possui permissÃ£o para acessar Campanhas PRO!");
        setTimeout(() => history.push("/"), 1000);
      }
    }
    fetchData();
  }, [getPlanCompany, history, user.companyId]);

  // Reset ao mudar filtros
  useEffect(() => {
    if (activeTab === 0) {
      dispatchCampaigns({ type: "RESET" });
    } else {
      dispatchContactLists({ type: "RESET" });
    }
    setPageNumber(1);
  }, [searchParam, statusFilter, activeTab, pageSize]);

  // Carregar dados
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      if (activeTab === 0) {
        fetchCampaigns();
      } else {
        fetchContactLists();
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber, statusFilter, activeTab, pageSize]);
  /* eslint-enable react-hooks/exhaustive-deps */

  // Socket listeners
  useEffect(() => {
    const companyId = user.companyId;

    const onCampaignPro = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatchCampaigns({ type: "UPDATE_DATA", payload: data.record });
      }
      if (data.action === "delete") {
        dispatchCampaigns({ type: "DELETE_DATA", payload: +data.id });
      }
    };

    const onContactListPro = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatchContactLists({ type: "UPDATE_DATA", payload: data.record });
      }
      if (data.action === "delete") {
        dispatchContactLists({ type: "DELETE_DATA", payload: +data.id });
      }
    };

    socket.on(`company-${companyId}-CampaignPro`, onCampaignPro);
    socket.on(`company-${companyId}-ContactListPro`, onContactListPro);

    return () => {
      socket.off(`company-${companyId}-CampaignPro`, onCampaignPro);
      socket.off(`company-${companyId}-ContactListPro`, onContactListPro);
    };
  }, [socket, user.companyId]);

  const fetchCampaigns = async () => {
    try {
      const { data } = await api.get("/campaigns-pro", {
        params: {
          searchParam,
          pageNumber,
          pageSize,
          status: statusFilter,
        },
      });

      if (pageNumber === 1) {
        dispatchCampaigns({ type: "RESET" });
      }
      dispatchCampaigns({ type: "LOAD_DATA", payload: data.records });
      setTotalCount(data.count || 0);
      setLoading(false);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  const fetchContactLists = async () => {
    try {
      const { data } = await api.get("/contact-lists-pro", {
        params: { searchParam, pageNumber },
      });

      if (pageNumber === 1) {
        dispatchContactLists({ type: "RESET" });
      }
      dispatchContactLists({ type: "LOAD_DATA", payload: data.records });
      setTotalCount(data.count || 0);
      setLoading(false);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handlePageChange = (event, newPage) => {
    setPageNumber(newPage + 1);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setPageNumber(1);
  };

  // Campanhas
  const handleOpenCampaignModal = () => {
    setSelectedCampaign(null);
    setCampaignModalOpen(true);
  };

  const handleCloseCampaignModal = () => {
    setSelectedCampaign(null);
    setCampaignModalOpen(false);
  };

  const handleEditCampaign = (campaign) => {
    setSelectedCampaign(campaign);
    setCampaignModalOpen(true);
  };

  const handleDeleteCampaign = async (campaignId) => {
    try {
      await api.delete(`/campaigns-pro/${campaignId}`);
      toast.success("Campanha excluÃ­da!");
    } catch (err) {
      toastError(err);
    }
    setDeletingCampaign(null);
    setPageNumber(1);
    fetchCampaigns();
  };

  const cancelCampaign = async (campaign) => {
    try {
      await api.post(`/campaigns-pro/${campaign.id}/cancel`);
      toast.success("Campanha cancelada!");
      fetchCampaigns();
    } catch (err) {
      toastError(err);
    }
  };

  const restartCampaign = async (campaign) => {
    try {
      await api.post(`/campaigns-pro/${campaign.id}/restart`);
      toast.success("Campanha reiniciada!");
      fetchCampaigns();
    } catch (err) {
      toastError(err);
    }
  };

  // Listas de Contatos
  const handleDeleteContactList = async (listId) => {
    try {
      await api.delete(`/contact-lists-pro/${listId}`);
      toast.success("Lista excluÃ­da!");
    } catch (err) {
      toastError(err);
    }
    setDeletingContactList(null);
    setPageNumber(1);
    fetchContactLists();
  };

  const handleExportList = async (list) => {
    setExportingListId(list.id);
    try {
      const { data } = await api.get(`/contact-lists-pro/${list.id}/items`, {
        params: { pageNumber: 1, pageSize: 99999 }
      });
      const records = data.records || [];
      const headers = ["Nome", "NÃºmero", "WhatsApp VÃ¡lido", "Var1", "Var2", "Var3", "Var4", "Var5", "Var6", "Tags"];
      const csvRows = [
        headers.join(";"),
        ...records.map((r) =>
          [
            (r.name || "").replace(/;/g, ","),
            r.number || "",
            r.isWhatsappValid ? "Sim" : "NÃ£o",
            (r.var1 || "").replace(/;/g, ","),
            (r.var2 || "").replace(/;/g, ","),
            (r.var3 || "").replace(/;/g, ","),
            (r.var4 || "").replace(/;/g, ","),
            (r.var5 || "").replace(/;/g, ","),
            (r.var6 || "").replace(/;/g, ","),
            (r.tags || "").replace(/;/g, ",")
          ].join(";")
        )
      ];
      const blob = new Blob(["\uFEFF" + csvRows.join("\r\n")], { type: "text/csv;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `lista_${(list.name || "contatos").replace(/[^a-zA-Z0-9]/g, "_")}.csv`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success(`Exportados ${records.length} contatos.`);
    } catch (err) {
      toastError(err);
    }
    setExportingListId(null);
  };

  const handleValidateContacts = async (list) => {
    setValidatingListId(list.id);
    try {
      const { data } = await api.post(`/contact-lists-pro/${list.id}/validate`);
      toast.success(
        `ValidaÃ§Ã£o concluÃ­da: ${data.valid || 0} vÃ¡lidos, ${data.invalid || 0} invÃ¡lidos (${data.validated || 0} total).`
      );
      fetchContactLists();
    } catch (err) {
      toastError(err);
    }
    setValidatingListId(null);
  };

  const formatStatus = (val) => {
    switch (val) {
      case "INATIVA": return "Inativa";
      case "PROGRAMADA": return "Programada";
      case "EM_ANDAMENTO": return "Em Andamento";
      case "PAUSADA": return "Pausada";
      case "CANCELADA": return "Cancelada";
      case "FINALIZADA": return "Finalizada";
      default: return val;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "INATIVA": return "default";
      case "PROGRAMADA": return "primary";
      case "EM_ANDAMENTO": return "secondary";
      case "PAUSADA": return "default";
      case "CANCELADA": return "default";
      case "FINALIZADA": return "default";
      default: return "default";
    }
  };

  const renderCampaignsTab = () => (
    <>
      <Paper className={classes.statsCard}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              placeholder="Buscar campanha..."
              type="search"
              value={searchParam}
              onChange={handleSearch}
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: "gray" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel>Status</InputLabel>
              <Select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                label="Status"
              >
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="INATIVA">Inativa</MenuItem>
                <MenuItem value="PROGRAMADA">Programada</MenuItem>
                <MenuItem value="EM_ANDAMENTO">Em Andamento</MenuItem>
                <MenuItem value="CANCELADA">Cancelada</MenuItem>
                <MenuItem value="FINALIZADA">Finalizada</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleOpenCampaignModal}
              startIcon={<AddIcon />}
            >
              Nova Campanha PRO
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Paper className={classes.mainPaper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHeader}>Nome</TableCell>
              <TableCell className={classes.tableHeader} align="center">Status</TableCell>
              <TableCell className={classes.tableHeader} align="center">Lista de Contatos</TableCell>
              <TableCell className={classes.tableHeader} align="center">WhatsApp</TableCell>
              <TableCell className={classes.tableHeader} align="center">Agendado</TableCell>
              <TableCell className={classes.tableHeader} align="center">AÃ§Ãµes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {campaigns.map((campaign) => (
              <TableRow key={campaign.id}>
                <TableCell>{campaign.name}</TableCell>
                <TableCell align="center">
                  <Chip
                    label={formatStatus(campaign.status)}
                    color={getStatusColor(campaign.status)}
                    size="small"
                    className={classes.statusChip}
                  />
                </TableCell>
                <TableCell align="center">
                  {campaign.contactListPro?.name || "â€”"}
                </TableCell>
                <TableCell align="center">
                  {campaign.whatsapp?.name || "â€”"}
                </TableCell>
                <TableCell align="center">
                  {campaign.scheduledAt ? datetimeToClient(campaign.scheduledAt) : "â€”"}
                </TableCell>
                <TableCell align="center">
                  <div className={classes.actionButtons}>
                    {campaign.status === "EM_ANDAMENTO" && (
                      <Tooltip title="Pausar">
                        <IconButton size="small" onClick={() => cancelCampaign(campaign)}>
                          <PauseCircleOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    {campaign.status === "CANCELADA" && (
                      <Tooltip title="Reiniciar">
                        <IconButton size="small" onClick={() => restartCampaign(campaign)}>
                          <PlayCircleOutlineIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip title="RelatÃ³rio">
                      <IconButton
                        size="small"
                        onClick={() => history.push(`/campaigns-pro/${campaign.id}/report`)}
                      >
                        <AssessmentIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Editar">
                      <IconButton size="small" onClick={() => handleEditCampaign(campaign)}>
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Excluir">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setConfirmCampaignModalOpen(true);
                          setDeletingCampaign(campaign);
                        }}
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                </TableCell>
              </TableRow>
            ))}
            {loading && <TableRowSkeleton columns={6} />}
            {!loading && campaigns.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className={classes.emptyState}>
                  <Typography variant="body1">
                    Nenhuma campanha encontrada. Crie sua primeira campanha PRO!
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <Box display="flex" justifyContent="flex-end" p={2}>
          <TablePagination
            component="div"
            count={totalCount}
            page={pageNumber - 1}
            onPageChange={handlePageChange}
            rowsPerPage={pageSize}
            onRowsPerPageChange={handlePageSizeChange}
            rowsPerPageOptions={[5, 10, 25, 50]}
            labelRowsPerPage="Por pÃ¡gina:"
          />
        </Box>
      </Paper>
    </>
  );

  const renderContactListsTab = () => (
    <>
      <Paper className={classes.statsCard}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              placeholder="Buscar lista..."
              type="search"
              value={searchParam}
              onChange={handleSearch}
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: "gray" }} />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => {
                setSelectedListForImport(null);
                setImportWizardOpen(true);
              }}
              startIcon={<CloudUploadIcon />}
            >
              Importar Contatos
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              onClick={() => {
                setSelectedListForManualAdd(null);
                setManualAddModalOpen(true);
              }}
              startIcon={<AddIcon />}
            >
              Adicionar Manualmente
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Paper className={classes.mainPaper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHeader}>Nome da Lista</TableCell>
              <TableCell className={classes.tableHeader} align="center">Contatos</TableCell>
              <TableCell className={classes.tableHeader} align="center">Importados</TableCell>
              <TableCell className={classes.tableHeader} align="center">Duplicados</TableCell>
              <TableCell className={classes.tableHeader} align="center">InvÃ¡lidos</TableCell>
              <TableCell className={classes.tableHeader} align="center">AÃ§Ãµes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contactLists.map((list) => (
              <TableRow key={list.id}>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={1}>
                    <PeopleIcon color="primary" />
                    {list.name}
                  </Box>
                </TableCell>
                <TableCell align="center">
                  <Chip label={list.contactsCount || 0} size="small" color="primary" />
                </TableCell>
                <TableCell align="center" style={{ color: "#4caf50" }}>
                  {list.totalImported || 0}
                </TableCell>
                <TableCell align="center" style={{ color: "#ff9800" }}>
                  {list.totalDuplicates || 0}
                </TableCell>
                <TableCell align="center" style={{ color: "#f44336" }}>
                  {list.totalInvalid || 0}
                </TableCell>
                <TableCell align="center">
                  <div className={classes.actionButtons}>
                    <Tooltip title="Adicionar Contatos Manualmente">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setSelectedListForManualAdd(list);
                          setManualAddModalOpen(true);
                        }}
                        color="primary"
                      >
                        <AddIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Importar Arquivo">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setSelectedListForImport(list);
                          setImportWizardOpen(true);
                        }}
                        color="secondary"
                      >
                        <CloudUploadIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Ver Contatos">
                      <IconButton
                        size="small"
                        onClick={() => history.push(`/campaigns-pro/lists/${list.id}`)}
                      >
                        <ListAltIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Exportar lista">
                      <IconButton
                        size="small"
                        onClick={() => handleExportList(list)}
                        disabled={exportingListId === list.id}
                        style={{ color: "#2e7d32" }}
                      >
                        <GetAppIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Validar contatos (WhatsApp)">
                      <IconButton
                        size="small"
                        onClick={() => handleValidateContacts(list)}
                        disabled={validatingListId === list.id}
                        style={{ color: "#1565c0" }}
                      >
                        <VerifiedUserIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Excluir">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setConfirmContactListModalOpen(true);
                          setDeletingContactList(list);
                        }}
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                </TableCell>
              </TableRow>
            ))}
            {loading && <TableRowSkeleton columns={6} />}
            {!loading && contactLists.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className={classes.emptyState}>
                  <Typography variant="body1">
                    Nenhuma lista encontrada. Importe seus contatos!
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </>
  );

  if (user.profile === "user" && user?.showCampaign === "disabled") {
    return <ForbiddenPage />;
  }

  return (
    <MainContainer>
      <ConfirmationModal
        title={deletingCampaign && `Excluir campanha "${deletingCampaign.name}"?`}
        open={confirmCampaignModalOpen}
        onClose={() => setConfirmCampaignModalOpen(false)}
        onConfirm={() => handleDeleteCampaign(deletingCampaign.id)}
      >
        Esta aÃ§Ã£o nÃ£o pode ser desfeita.
      </ConfirmationModal>

      <ConfirmationModal
        title={deletingContactList && `Excluir lista "${deletingContactList.name}"?`}
        open={confirmContactListModalOpen}
        onClose={() => setConfirmContactListModalOpen(false)}
        onConfirm={() => handleDeleteContactList(deletingContactList.id)}
      >
        Todos os contatos desta lista serÃ£o excluÃ­dos. Esta aÃ§Ã£o nÃ£o pode ser desfeita.
      </ConfirmationModal>

      {campaignModalOpen && (
        <CampaignProModal
          open={campaignModalOpen}
          onClose={handleCloseCampaignModal}
          campaignId={selectedCampaign?.id}
          resetPagination={() => {
            setPageNumber(1);
            fetchCampaigns();
          }}
        />
      )}

      <ContactListProImportWizard
        open={importWizardOpen}
        onClose={() => {
          setImportWizardOpen(false);
          setSelectedListForImport(null);
        }}
        onSuccess={() => {
          setPageNumber(1);
          fetchContactLists();
        }}
        existingListId={selectedListForImport?.id}
        existingListName={selectedListForImport?.name}
      />

      <ManualAddContactsModal
        open={manualAddModalOpen}
        onClose={() => {
          setManualAddModalOpen(false);
          setSelectedListForManualAdd(null);
        }}
        contactListProId={selectedListForManualAdd?.id}
        onSuccess={() => {
          fetchContactLists();
        }}
      />

      <MainHeader>
        <Title>ðŸš€ Campanhas PRO</Title>
      </MainHeader>

      <Paper className={classes.tabsContainer}>
        <Tabs
          value={activeTab}
          onChange={(e, v) => setActiveTab(v)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab
            label={
              <Box display="flex" alignItems="center" gap={1}>
                <DescriptionIcon />
                <span>Campanhas</span>
                {campaigns.length > 0 && (
                  <Badge badgeContent={campaigns.length} color="primary" />
                )}
              </Box>
            }
          />
          <Tab
            label={
              <Box display="flex" alignItems="center" gap={1}>
                <PeopleIcon />
                <span>Listas de Contatos</span>
                {contactLists.length > 0 && (
                  <Badge badgeContent={contactLists.length} color="primary" />
                )}
              </Box>
            }
          />
        </Tabs>
      </Paper>

      {activeTab === 0 && renderCampaignsTab()}
      {activeTab === 1 && renderContactListsTab()}
    </MainContainer>
  );
};

export default CampaignsPro;

